module.exports = __webpack_public_path__ + "static/media/match.aeb7e47c.png";